import gql from 'graphql-tag';

import recentlyViewedMainDisplayObjectFragment from './recentlyViewedMainDisplayObjectFragment';

export const recentlyViewedMainDisplayObjectsGroupedByIntegrationItemKindFragment = gql`
  fragment recentlyViewedMainDisplayObjectsGroupedByIntegrationItemKindFragment on RecentlyViewedMainDisplayObjectsGroupedByIntegrationItemKind {
    dokkioClass
    integrationItemKind
    recentlyViewedMainDisplayObjects {
      ...recentlyViewedMainDisplayObjectFragment
    }
  }
  ${recentlyViewedMainDisplayObjectFragment}
`;
export default recentlyViewedMainDisplayObjectsGroupedByIntegrationItemKindFragment;
